// Place default language first
export const LanguagesEnum = {
  EN: 'EN',
  DE: 'DE',
  // FR = 'FR',
} as const;

export type TLanguage = keyof typeof LanguagesEnum;

export interface LanguageOption {
  value: keyof typeof LanguagesEnum;
  i18n: string;
}

export const LANGUAGES: LanguageOption[] = [
  { value: LanguagesEnum.EN, i18n: 'ENGLISH' },
  { value: LanguagesEnum.DE, i18n: 'GERMAN' },
];
